import React from 'react'
import { VideoPlayer } from '@/component/Primitive/Events'

export const EventLivePlayer = (props) => <VideoPlayer live {...props} />
